export default __webpack_public_path__ + "media/images/get-ready/google-a491be39c05cad489a3480e2d2bdcf61.png";